import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { pillars } from '../../data/whatYouGet';
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-271" data-mp="143gjy1emab8g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-272" data-mp="100tqxx67mk9o">
        <SectionTag icon="🎁" data-id="element-273" data-mp="zzinxzkl9gjm">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-274" data-mp="1dza5ube87h2w">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-275" data-mp="1nqwi8b2avm78">
          Más de 150 sesiones para que preparar el entrenamiento deje de comerse tu tiempo.
        </p>
        <p className="mt-2 text-sm font-medium text-naranja" data-id="element-276" data-mp="1wqtaemnwf371">
          Más de 150 sesiones · 6 Tomos · +10 Meses de entrenamiento · 100% Digital
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-277" data-mp="1rpwvle20dwmu">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border-2 border-naranja bg-white p-6 shadow-card sm:p-7" data-id="element-278" data-mp="2zxf19evbjmc2" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-279" data-mp="3dx6al2aw4ejq">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-azul-light" data-id="element-280" data-mp="3ivhllgcx8v3j">
                <pillar.icon size={22} className="text-azul" data-id="element-281" data-mp="3nnri5f8jktes" />
              </div>
              <span className="rounded-full bg-verde-light px-3 py-1 text-xs font-semibold text-verde" data-id="element-282" data-mp="3slau28hrou3k">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-azul-dark sm:text-xl" data-id="element-283" data-mp="5hd4lhe6qlgx">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-284" data-mp="22iiokyyckzf0">
              <span className="text-rojo line-through" data-id="element-285" data-mp="1xk8t0n8pnwsv">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-286" data-mp="2bb46kcu5n22s">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-287" data-mp="26jcdnvnj0k9h">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-288" data-mp="2l8s41aj5anon">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-gris-oscuro" data-id="element-289" data-mp="2g9ntogkhijwq">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-290" data-mp="2u96mm24q5oog" />
                  <span data-id="element-291" data-mp="2q7v6qobnkhtg">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}